import React from 'react';
import { FaStar, FaHandPaper, FaMagic, FaHeart, FaCalculator, FaHome, FaBriefcase, FaBuilding, FaBaby, FaPray } from 'react-icons/fa';
import { Link } from 'react-scroll';

const Services = () => {
  const services = [
    {
      icon: <FaStar />,
      title: "Astrology",
      description: "Comprehensive Vedic astrology readings including birth chart analysis, planetary positions, and future predictions based on ancient wisdom.",
      price: "₹2,500",
      duration: "60 mins",
      features: ["Birth chart analysis", "Planetary predictions", "Life guidance", "Timing analysis"]
    },
    {
      icon: <FaCalculator />,
      title: "Numerology",
      description: "Discover the power of numbers in your life through detailed numerological analysis and personalized number guidance.",
      price: "₹2,000",
      duration: "45 mins",
      features: ["Life path number", "Lucky numbers", "Name analysis", "Career numbers"]
    },
    {
      icon: <FaHome />,
      title: "Vastu Consultant",
      description: "Expert Vastu Shastra consultation for homes and offices to create harmony, prosperity, and positive energy flow.",
      price: "₹3,500",
      duration: "90 mins",
      features: ["Home/office analysis", "Directional guidance", "Energy enhancement", "Remedial measures"]
    },
    {
      icon: <FaMagic />,
      title: "Tantra/Mantra",
      description: "Sacred Tantra and Mantra practices to remove obstacles, spiritual cleansing, and divine protection through ancient rituals.",
      price: "₹4,000",
      duration: "75 mins",
      features: ["Obstacle removal", "Spiritual cleansing", "Divine protection", "Sacred rituals"]
    },
    {
      icon: <FaHeart />,
      title: "Marriage-related Issues",
      description: "Complete marriage consultation including compatibility analysis, timing, and solutions for marital harmony and relationship issues.",
      price: "₹3,000",
      duration: "60 mins",
      features: ["Compatibility check", "Marriage timing", "Relationship harmony", "Family issues"]
    },
    {
      icon: <FaBriefcase />,
      title: "Career Direction",
      description: "Professional guidance for career choices, job changes, business decisions, and achieving success in your professional life.",
      price: "₹2,800",
      duration: "55 mins",
      features: ["Career guidance", "Job timing", "Professional growth", "Success strategies"]
    },
    {
      icon: <FaBuilding />,
      title: "Business Success",
      description: "Strategic astrological advice for business growth, partnerships, investments, and overcoming business challenges.",
      price: "₹4,500",
      duration: "90 mins",
      features: ["Business growth", "Partnership advice", "Investment timing", "Success remedies"]
    },
    {
      icon: <FaHandPaper />,
      title: "Property Disputes",
      description: "Specialized consultation for property-related issues, land disputes, and real estate decisions using astrological insights.",
      price: "₹3,200",
      duration: "70 mins",
      features: ["Property analysis", "Dispute resolution", "Land guidance", "Legal timing"]
    },
    {
      icon: <FaBaby />,
      title: "Delayed Childbirth",
      description: "Compassionate guidance for fertility issues, childbirth timing, and remedial measures for conception and healthy pregnancy.",
      price: "₹3,500",
      duration: "60 mins",
      features: ["Fertility guidance", "Conception timing", "Health remedies", "Child prediction"]
    },
    {
      icon: <FaPray />,
      title: "Spiritual Progress",
      description: "Deep spiritual consultation for inner growth, meditation guidance, karmic healing, and advancing on your spiritual journey.",
      price: "₹4,000",
      duration: "80 mins",
      features: ["Spiritual guidance", "Karmic healing", "Meditation advice", "Soul evolution"]
    }
  ];

  return (
    <section id="services" className="section-padding bg-gray-50">
      <div className="container-max">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="section-title">
            Our <span className="gradient-text">Services</span>
          </h2>
          <p className="section-subtitle">
            Comprehensive spiritual and astrological services to guide you through life's journey with ancient wisdom and modern insights
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={service.title}
              className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 card-hover border border-gray-100"
            >
              {/* Service Icon */}
              <div className="w-16 h-16 bg-gradient-to-br from-primary to-secondary rounded-xl flex items-center justify-center mb-6 mx-auto">
                <div className="text-white text-2xl">
                  {service.icon}
                </div>
              </div>

              {/* Service Title */}
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center font-heading">
                {service.title}
              </h3>

              {/* Service Description */}
              <p className="text-gray-600 text-sm mb-6 leading-relaxed text-center">
                {service.description}
              </p>

              {/* Features */}
              <ul className="space-y-3 mb-6">
                {service.features.map((feature, idx) => (
                  <li key={`${service.title}-${feature}`} className="flex items-center space-x-3 text-sm text-gray-700">
                    <div className="w-2 h-2 bg-primary rounded-full flex-shrink-0"></div>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              {/* Price and Duration */}
              <div className="border-t border-gray-100 pt-4 flex justify-between items-center mb-6">
                <div className="text-center">
                  <div className="text-2xl font-bold gradient-text">{service.price}</div>
                  <div className="text-xs text-gray-500">Starting from</div>
                </div>
                <div className="text-center">
                  <div className="text-lg font-semibold text-gray-900">{service.duration}</div>
                  <div className="text-xs text-gray-500">Session</div>
                </div>
              </div>

              {/* Book Button */}
              <button className="w-full btn-primary">
                <Link
                    to="contact"
                    smooth={true}
                    duration={500}
                    offset={-70}
                    className="btn-primary cursor-pointer text-center"
                  >
                    Book Reading
                  </Link>
              </button>
            </div>
          ))}
        </div>

        {/* Client Showcase */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 font-heading">
            Trusted by Amazing People Worldwide
          </h3>
          <div className="flex flex-wrap justify-center items-center gap-4 mb-8">
            {[
              'IMG-20250831-WA0017.jpg', 'IMG-20250831-WA0022.jpg', 'IMG-20250831-WA0028.jpg',
              'IMG-20250831-WA0034.jpg', 'IMG-20250831-WA0035.jpg', 'IMG-20250831-WA0038.jpg',
              'IMG-20250831-WA0036.jpg', 'IMG-20250831-WA0037.jpg'
            ].map((img, index) => (
              <div key={img} className="w-12 h-12 rounded-full overflow-hidden border-2 border-primary/20 hover:border-primary transition-all duration-300 hover:scale-110">
                <img 
                  src={`/images/user/${img}`} 
                  alt={`Client ${index + 1}`}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextElementSibling.style.display = 'flex';
                  }}
                />
                <div className="w-full h-full bg-gradient-to-br from-primary/20 to-secondary/20 hidden items-center justify-center">
                  <div className="w-3 h-3 bg-primary rounded-full"></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Special Offer */}
        <div className="mt-8 bg-gradient-to-r from-primary/5 to-secondary/5 p-8 rounded-xl border border-primary/10 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4 font-heading">
            First Time Client Special
          </h3>
          <p className="text-gray-600 mb-6">
            Get 20% off your first reading and discover what the stars have in store for you
          </p>
          <button className="btn-primary">
            Claim Your Discount
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
